import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from '../common/PageTitleBanner';

const About = () => {
    return (
        <>
            <PageTitle subtitle="About" title="Who we are" bannerImage="assets/images/banner.jpg" />
         
            <section className="content-section">
                <Container>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="sub-heading mb-4">Know more about!</div>
                            <div className="heading mb-4"><span className="weight-light"> A team with
                            </span> experience
                                and vision </div>
                            <div className="para-txt txt-large mb-5">
                                <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name</p>
                            </div>
                            <ul className="listul-style">
                                <li>Rudra Structural &amp; Services (RSS) is India's leading Specialty Engineering and Contracting Solutions Provider in the field of Repairs, Rehabilitation, Retrofitting of RCC structures, Polyester Coatings, Corrosion mitigation &amp; Waterproofing, Flooring and Protective Coatings, General civil work &amp; roofing &amp; structural services.</li>
                                <li>RSS stand for quality and reliability of works, timely completion of projects, closest supervision of all sites, best projects, closest supervision of all sites, best project management, quick response to customer needs and technical supports services.</li>
                                <li>As a progressive engineering company with expertise in several interconnected areas, RSS offers a one-stop-solution to customers for various structural requirements.</li>
                                <li>Our subsidiary, RSS LLC, Dubai caters to the demand for repairs, rehabilitation and coatings in the Middle East region.</li>
                            </ul>
                        </div>
                        <div className="col-lg-6 col-xl-5 offset-xl-1">
                            <div className="image-wrap d-none d-lg-block">
                                <img src="./assets/images/about.jpeg" width="100%" alt="" />
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
            <section className="content-section lightbg">
                <Container>
                    <div className="sub-heading mb-4">What We Do?</div>
                    <div className="heading mb-4"><span className="weight-light">We Offer</span> Services</div>
                    <div className="para-txt mb-5 txt-large">
                        <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name</p>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="white-block">
                                <div className="service-block mb-0">
                                    <span className="icon">
                                        <img src="./assets/images/icons/architect.png" alt="" />
                                    </span>
                                    <div className="service-meta">
                                        <h4 className="h4-style mb-2">Repairs & Strengthening</h4>
                                        <div className="para-txt">
                                            <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="white-block">
                                <div className="service-block mb-0">
                                    <span className="icon">
                                        <img src="./assets/images/icons/brickwall.png" alt="" />
                                    </span>
                                    <div className="service-meta">
                                        <h4 className="h4-style mb-2">Retrofitting</h4>
                                        <div className="para-txt">
                                            <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="white-block">
                                <div className="service-block mb-0">
                                    <span className="icon">
                                        <img src="./assets/images/icons/helmet.png" alt="" />
                                    </span>
                                    <div className="service-meta">
                                        <h4 className="h4-style mb-2">Specialized Coatings</h4>
                                        <div className="para-txt">
                                            <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="white-block">
                                <div className="service-block mb-0">
                                    <span className="icon">
                                        <img src="./assets/images/icons/hook.png" alt="" />
                                    </span>
                                    <div className="service-meta">
                                        <h4 className="h4-style mb-2">Waterproofing</h4>
                                        <div className="para-txt">
                                            <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="white-block">
                                <div className="service-block mb-0">
                                    <span className="icon">
                                        <img src="./assets/images/icons/house.png" alt="" />
                                    </span>
                                    <div className="service-meta">
                                        <h4 className="h4-style mb-2">Floor & Wall Coatings</h4>
                                        <div className="para-txt">
                                            <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="white-block">
                                <div className="service-block mb-0">
                                    <span className="icon">
                                        <img src="./assets/images/icons/sketch.png" alt="" />
                                    </span>
                                    <div className="service-meta">
                                        <h4 className="h4-style mb-2">Corrosion Mitigation</h4>
                                        <div className="para-txt">
                                            <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
            <section className="content-section">
                <Container>
                    <div className="row">
                        <div className="col-lg-6 col-xl-6">
                            <div className="heading mb-4"><span className="weight-light">Our
                            </span> Mission </div>
                            <div className="para-txt txt-large mb-5">
                                <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-5 offset-xl-1">
                            <div className="heading mb-4"><span className="weight-light">Our
                            </span> Vision </div>
                            <div className="para-txt txt-large">
                                <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name</p>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
            <section className="content-section lightbg">
                <Container>
                <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <div className="heading heading-md text-center mb-3"><span className="weight-light">Did you love</span> our work?</div>
                            <div className="para-txt txt-large text-center mb-5">
                                <p>
                                    In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without
                                </p>
                            </div>
                            <div className="text-center">
                                <Link to="/contact" className="button">Get A Quote</Link>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </>
    )
}
export default About;